import { MARK_LINK, render } from 'storyblok-rich-text-react-renderer'

// TODO: Typings. See https://www.npmjs.com/package/storyblok-rich-text-react-renderer
type Props = {
  document: any
  resolvers?: any
}

export function RichText({ document, resolvers }: Props) {
  return render(document, {
    markResolvers: {
      [MARK_LINK]: (children, props) => {
        const { linktype, href, target } = props
        const isExternal = linktype === 'url' && href?.match(/^(https?:)?\/\//)

        return (
          <a href={href} target={isExternal ? '_blank' : target}>
            {children}
          </a>
        )
      },
    },
  })
}
